import React from 'react'

import { Field } from 'formik'
import { ZariContext } from '_zari/context'
import { Form, Col, Row } from '_zari/core'
import { Select2SocioOtros } from 'sharedComponents/select2'
import { useFormikContext } from 'formik'

import * as SocioCrud from 'services/socio.service'
import * as RolCrud from 'services/rol.service'
import { KeyEventUtil } from 'utils'

const RolesTab = ({ rolesSeleccionados }) => {
  const __zariContext = React.useContext(ZariContext)
  const [roles, setRoles] = React.useState([])
  const { values, setFieldValue } = useFormikContext()

  React.useEffect(() => {
    RolCrud.obtenerAsSelect()
      .then(({ data }) => setRoles(data))
      .catch(({ data: { error } }) => __zariContext.snack('error', error))

    if (values._idSocio && !values.razonSocialSocio) {
      SocioCrud.obtenerxIdAsInfoSlim(values._idSocio).then(({ data }) => {
        setFieldValue('numeroDocumentoSocio', data.numeroDocumento || '')
        setFieldValue('razonSocialSocio', data.razonSocial || '')
      })
    }
  }, [__zariContext, values._idSocio, values.razonSocialSocio, setFieldValue])

  // ✅ useMemo SIEMPRE fuera de condicionales
  const socioSeleccionado = React.useMemo(() => {
    if (!values._idSocio) return null
    return {
      value: values._idSocio,
      label: values.razonSocialSocio
        ? `${values.razonSocialSocio} (${values.numeroDocumentoSocio})`
        : values._idSocio,
    }
  }, [values._idSocio, values.razonSocialSocio, values.numeroDocumentoSocio])

  const onChangeSocioHandler = pickedMember => {
    SocioCrud.obtenerxIdAsInfoSlim(pickedMember.value).then(({ data }) => {
      setFieldValue('_idSocio', pickedMember.value)
      setFieldValue('numeroDocumentoSocio', data.numeroDocumento || '')
      setFieldValue('razonSocialSocio', data.razonSocial || '')

      KeyEventUtil.leaveOnKeyEvent('select-partida')
    })
  }

  const debeMostrarSocio = roles.some(
    r => rolesSeleccionados.includes(r._id) && r.solicitaViaticos
  )

  return (
    <Row>
      <Col md={3} />
      <Col md={9}>
        {roles.map(x => (
          <React.Fragment key={x._id}>
            <Field name="_idsRoles">
              {({ field }) => (
                <Form.Checkbox
                  {...field}
                  id={`check-${x.nombre}`}
                  label={x.nombre}
                  value={x._id}
                  checked={rolesSeleccionados.some(z => z === x._id)}
                />
              )}
            </Field>
          </React.Fragment>
        ))}

        {debeMostrarSocio && (
          <Form.Group>
            <Form.Label text="Socio" htmlFor="select-sociootros" md={3} />
            <Col md={9}>
              <Select2SocioOtros
                id="select-sociootros"
                value={socioSeleccionado}
                onChange={onChangeSocioHandler}
              />
            </Col>

            <Col md={12} className="mt-2">
              <small>
                <b>Seleccionado:</b>{' '}
                {values.razonSocialSocio
                  ? `${values.razonSocialSocio} (${values.numeroDocumentoSocio})`
                  : '—'}
              </small>
            </Col>
          </Form.Group>
        )}
      </Col>
    </Row>
  )
}

export default React.memo(RolesTab)
